import React from 'react';

const Y_SCAFFOLD_CSS = `
.y-pagehead{font-family:var(--font-sans);display:flex;align-items:flex-end;
  justify-content:space-between;gap:24px;flex-wrap:wrap;}
.y-pagehead__eyebrow{font-size:10px;font-weight:600;letter-spacing:.12em;
  text-transform:uppercase;color:var(--yool-muted,#8D8D8D);margin:0;}
.y-pagehead__title{font-size:30px;font-weight:700;letter-spacing:-.03em;
  color:var(--yool-black,#1A1A1A);margin:8px 0 0;line-height:1.1;}
.y-pagehead__sub{font-size:15px;line-height:1.55;color:var(--yool-gray1,#54585A);
  margin:8px 0 0;max-width:60ch;}
.y-pagehead__actions{display:flex;align-items:center;gap:10px;flex-shrink:0;}
.y-section{font-family:var(--font-sans);}
.y-section + .y-section{margin-top:32px;}
.y-section--divider{border-top:1px solid var(--yool-border,#E0E0E0);padding-top:28px;}
.y-section__head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;flex-wrap:wrap;}
.y-section__heading{min-width:0;}
.y-section__actions{flex-shrink:0;display:flex;align-items:center;gap:10px;}
.y-section__title{font-size:17px;font-weight:700;letter-spacing:-.02em;
  color:var(--yool-black,#1A1A1A);margin:0;}
.y-section__desc{font-size:13.5px;line-height:1.5;color:var(--yool-gray1,#54585A);margin:6px 0 0;}
.y-section__body{margin-top:16px;}
.y-actionbar{font-family:var(--font-sans);display:flex;align-items:center;
  justify-content:flex-end;gap:10px;padding:16px 0;}
.y-actionbar--sticky{position:sticky;bottom:0;background:var(--yool-page,#F7F7F7);
  border-top:1px solid var(--yool-border,#E0E0E0);padding:16px 24px;
  margin:24px -24px 0;}
.y-actionbar__spacer{flex:1;}
`;

function ensureScaffoldStyles() {
  if (typeof document === 'undefined') return;
  if (document.getElementById('y-scaffold-css')) return;
  const s = document.createElement('style');
  s.id = 'y-scaffold-css';
  s.textContent = Y_SCAFFOLD_CSS;
  document.head.appendChild(s);
}

export function YoolPageHeader({ eyebrow, title, subtitle, actions, className = '', ...rest }) {
  ensureScaffoldStyles();
  return (
    <header className={['y-pagehead', className].filter(Boolean).join(' ')} {...rest}>
      <div>
        {eyebrow && <p className="y-pagehead__eyebrow">{eyebrow}</p>}
        {title && <h1 className="y-pagehead__title">{title}</h1>}
        {subtitle && <p className="y-pagehead__sub">{subtitle}</p>}
      </div>
      {actions && <div className="y-pagehead__actions">{actions}</div>}
    </header>
  );
}

export function YoolSection({ title, desc, actions, divider = false, children, className = '', ...rest }) {
  ensureScaffoldStyles();
  const cls = ['y-section', divider ? 'y-section--divider' : '', className].filter(Boolean).join(' ');
  return (
    <section className={cls} {...rest}>
      {(title || desc || actions) && (
        <div className="y-section__head">
          <div className="y-section__heading">
            {title && <h2 className="y-section__title">{title}</h2>}
            {desc && <p className="y-section__desc">{desc}</p>}
          </div>
          {actions && <div className="y-section__actions">{actions}</div>}
        </div>
      )}
      {children != null && <div className="y-section__body">{children}</div>}
    </section>
  );
}

export function YoolActionBar({ children, sticky = false, leading, className = '', ...rest }) {
  ensureScaffoldStyles();
  const cls = ['y-actionbar', sticky ? 'y-actionbar--sticky' : '', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {leading}
      <span className="y-actionbar__spacer" />
      {children}
    </div>
  );
}

export function YoolPageScaffold({ header, children, actions, sticky = false, className = '', ...rest }) {
  ensureScaffoldStyles();
  return (
    <div className={['y-pagescaffold', className].filter(Boolean).join(' ')} {...rest}>
      {header}
      {children != null && <div style={{ marginTop: 28 }}>{children}</div>}
      {actions && <YoolActionBar sticky={sticky}>{actions}</YoolActionBar>}
    </div>
  );
}
